import { SHORT_LINK } from '../constants';

export const getFacebookLink = () => {
  // using legacy sharer.php string to avoid creating app id
  return `https://www.facebook.com/sharer.php?u=${SHORT_LINK}`;
};

export const getTwitterLink = () => {
  return `https://twitter.com/intent/tweet?text=Check%20out%20this%20amazing%20experiment%20and%20transform%20your%20voice%20into%20instruments%21&url=${SHORT_LINK}&hashtags=tonetransfer`;
};
